import { HttpClientModule } from "@angular/common/http";
import { InjectionToken, NgModule } from '@angular/core';
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { Converter } from "@spartacus/core";
import { AppRoutingModule } from "@spartacus/storefront";
import { KbProductUrlNormalizer } from "./spartacus/custom-feature/nyab-doc-search-page/service/Product-list/kb-product-url.normalizer";
import { SpartacusModule } from "./spartacus/spartacus.module";
import { FooterModule } from "../app/spartacus/custom-feature/common/components/footer/footer.module";
export const KB_PRODUCT_URL_NORMALIZER = new InjectionToken<Converter<any, any>>('KbProductUrlNormalizer');

@NgModule({
  imports: [
    HttpClientModule,
    AppRoutingModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    SpartacusModule,
    FooterModule
  ],
  providers: [{
    provide: KB_PRODUCT_URL_NORMALIZER,
    useExisting: KbProductUrlNormalizer,
    multi: true,
  }
  ]
})
export class AppModule { }
